export default __webpack_public_path__ + "static/O0211-e5779bbb6a84e078ff1538bfc7ff261a.png";